
import { Vue, Component, Prop } from 'vue-property-decorator';
import { approvalRequestsAPI } from '@/providers/apis/approval-requests/approval-requests';
import moment from 'moment';
@Component({
    name: 'registration-approval-popup',

})

export default class RegistrationApprovalPopup extends Vue {

    @Prop()
    private editUserDetails: any;
    @Prop()
    private rejectedReason: any;
    @Prop()
    private getApprovedData: any;
    @Prop()
    private getRejectedData: any;
    @Prop()
    private getIndexItemapprovals: any;
    @Prop()
    private RegistrationApprovalsList: any;
    @Prop()
    private selectedRows: any = [];
    @Prop()
    private getSelectedRowId: any = [];

    private schoolsListData: any = [];
    private getSelectedRowIdRejected: any = [];
    private getGradeList: any = [];
    private firstName = '';
    private LastName = '';
    private emailId = '';
    private schoolsDetailsName = '';
    private schoolsDetailsId = '';
    private commentsField = '';
    private getGradeName = '';
    private getGradeId = '';
    private errorMsgEmail = false;

    private pageLoader = false;
    private commentsRejectedErrorMsg = false;

    private created() {
        this.firstName = this.getIndexItemapprovals.item.first_name;
        this.LastName = this.getIndexItemapprovals.item.last_name;
        this.emailId = this.getIndexItemapprovals.item.email;
        this.schoolsDetailsName = this.getIndexItemapprovals.item.groups.name;
        this.schoolsDetailsId = this.getIndexItemapprovals.item.groups.id;
        this.getGradeName = this.getIndexItemapprovals.item.info == null ? '-' :
            this.getIndexItemapprovals.item.info.grade.name;
        this.getGradeId = this.getIndexItemapprovals.item.info == null ? '-' :
            this.getIndexItemapprovals.item.info.grade.id;

        this.getSchoolListData();
        this.getGradeListData();
    }
    private commentsShowErrorMsg() {

        if (this.commentsField.length > 0) {
            this.commentsRejectedErrorMsg = false;
        } else {
            this.commentsRejectedErrorMsg = true;
        }
    }


    private getGradeListData() {
        approvalRequestsAPI.getGradeId().then((response: any) => {
            this.getGradeList = response.data.common_grade_levels;
        });
    }
    private getSchoolListData() {
        const params: any = {
            type: 'school',
        };
        approvalRequestsAPI.getSubjectList(params).then((response: any) => {
            this.schoolsListData = response.data.results;
        });
    }
    private saveEditDetailes() {
        this.edituserDetailes();
    }

    private getSchoolsListTownName(data: any) {
        (this.$refs.dropdownSchools as any).hide();
        this.schoolsDetailsName = data.name;
        this.schoolsDetailsId = data.id;
    }

    private getGradeListId(data: any) {
        (this.$refs.dropdown as any).hide();
        this.getGradeName = data.name;
        this.getGradeId = data.id;
    }
    private edituserDetailes() {
        this.pageLoader = true;
        const Params: any = {
            id: this.getIndexItemapprovals.item.id,
            first_name: this.firstName,
            last_name: this.LastName,
            email: this.emailId === this.getIndexItemapprovals.item.email ? '' : this.emailId,
            group_school_id: this.schoolsDetailsId,
            info: {
                grade: {
                    id: this.getGradeId,
                    name: this.getGradeName,
                    last_updated_at: `${moment(new Date()).format('YYYY-MM-DD')}`,
                },
                where_in_life_are_you: 'I`m in school',
            },
            user_category: this.getIndexItemapprovals.item.user_category,
        };


        const result = Object.entries(Params).reduce((a: any, [k, v]) => (v === null
            || v === '' || v === undefined ? a :
            (a[k] = v, a)), {});
        approvalRequestsAPI.editUserData(result).then((response: any) => {
            if (response.status === 204) {
                this.pageLoader = false;
                this.RegistrationApprovalsList();
                this.$bvModal.hide('edit-user-detailes-popup');
            }
            if (response.message.response.data.statusCode === 409) {
                this.pageLoader = false;
                this.errorMsgEmail = true;
            }

        });


    }

    private closePopUp() {
        if (this.getApprovedData) {
            this.$bvModal.hide('account-verified-popup');
        } else if (this.getRejectedData) {
            this.$bvModal.hide('activation-rejected-popup');
        } else if (this.rejectedReason) {
            this.$bvModal.hide('rejected-reason-popup');
        } else {
            this.$bvModal.hide('edit-user-detailes-popup');

        }
    }
    private ActivationNotApproved() {
        if (this.commentsField.length === 0) {
            this.commentsRejectedErrorMsg = this.commentsField.length === 0 ? true : false;
        } else {

            this.pageLoader = true;

            this.selectedRows.forEach((item: any, index: any) => {
                if (item.status === 'pending') {
                    this.getSelectedRowIdRejected.push({
                        id: item.id, status: 'rejected',
                        comment: this.commentsField,
                    });

                }
            });
            const params: any = {};
            if (this.selectedRows.length > 0) {
                params.users = this.getSelectedRowIdRejected;
            } else {
                const id = this.getIndexItemapprovals.item.id;
                params.users = [
                    {
                        id,
                        status: 'rejected',
                        comment: this.commentsField,
                    },
                ];

            }
            approvalRequestsAPI.updateUserStaus(params).then((response: any) => {
                if (response.status === 200) {
                    this.selectedRows = [];
                    this.RegistrationApprovalsList();
                    this.pageLoader = false;
                    this.$bvModal.hide('activation-rejected-popup');
                }
            });
        }

    }




}
